module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.youtube-02ba97ae57e5b0c4943ef565fe5fb3a4.svg";